import creativeCommunityMemberBenefits from './contentfulExports/creativeCommunityMemberBenefits.json'

const useCreativeBenefits = () => {
  return creativeCommunityMemberBenefits;
}

export default useCreativeBenefits;
